<template>
	<h2 v-if="content">{{ subheaderTitle }}</h2>
</template>

<script setup>
	import { useI18n, useLocalePath } from '#imports'
	import { computed } from 'vue'
	const { locale } = useI18n()
	const localePath = useLocalePath()
	const props = defineProps({
		content: Object
	})
	let subheaderTitle
	if(props.content.title) {
		subheaderTitle = computed(() => locale.value === 'en' ? props.content.title.en : props.content.title.jp )
	}
</script>
